import React from 'react'
import ItemList from '../layout/ItemList'
import AddItemModal from '../layout/AddItemModal';
class AddItems extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            show: false,
            name: "",
            purchase_price:"1",
            sale_price:"1",
            qty:"1",
            barcode:"",
        };
        this.handleClose = this.handleClose.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleSubmitItem = this.handleSubmitItem.bind(this);
        this.handleEditClick = this.handleEditClick.bind(this);
        //this.handleRemoveClick = this.handleRemoveClick(this);
    }
    handleChange = (e) => {
        this.setState({[e.target.id]: e.target.value});
        
    };

    handleEditClick(e) {
        e.preventDefault();
        console.log(e);
        var clickedNode = null;
        e.target.innerHTML === "" ? clickedNode = e.target.parentNode.parentNode.parentNode.parentNode : clickedNode = e.target.parentNode.parentNode.parentNode;
        var itemsFromStorage = JSON.parse(localStorage.getItem("products"));
        var updatedItemsForStorage = itemsFromStorage.filter(product => product.barcode === clickedNode.id);
        console.log(updatedItemsForStorage);
        this.setState({
            
            name: updatedItemsForStorage[0].name,
            purchase_price: updatedItemsForStorage[0].purchase_price,
            sale_price: updatedItemsForStorage[0].sale_price,
            qty: updatedItemsForStorage[0].qty,
            barcode: updatedItemsForStorage[0].barcode,
            show:true,
        });

            }

    handleSubmitItem(e){
        console.log(e);
        if(this.state.name !== "" && this.state.barcode !== "" && this.state.qty !== "" && this.state.purchase_price !== ""
        && this.state.sale_price !== ""){
            this.props.addItemsOnClick(this.state);
            this.handleClose();
        }
    }

    // handleClick(e){
    //     e.preventDefault();
    //     console.log("blah2");
    //     localStorage.setItem('Name', 'Stewart');

    // }

    handleClose(){
        this.setState({
            show:false,
            name: "",
            purchase_price:"",
            sale_price:"",
            qty:"",
            barcode:"",
        })
    }
    handleClick(e){
        e.preventDefault();
        this.setState({
            show:true,
        })
    }
    

    render(){
        return(

        <React.Fragment>
            <AddItemModal props={this.props} state={this.state} show={this.state.show} handleClose={this.handleClose} handleSubmitItem={this.handleSubmitItem}
            addItemsOnClick={this.props.addItemsOnClick} />

            <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                <li className="breadcrumb-item"><a href="/">Home</a></li>
                <li className="breadcrumb-item"><a href="/admin">Admin</a></li>
                <li className="breadcrumb-item active" aria-current="page">Add Items</li>
                </ol>
            </nav>
            <div className="mt-4 p-5 bg-white text-black rounded text-center">
                <div className="container">
                    <h1 className="jumbotron-heading">Add new items</h1>
                    <p>Use this page add new items to your shop</p>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 d-block justify-content-center pl-3">
                    <div className="d-block justify-content-center pl-3">
                        <ItemList products={this.props.products} name={this.state.name} handleRemoveClick={this.props.handleRemoveClick} handleEditClick={this.handleEditClick}/>
                    </div>
                </div>

                <div className="col-md-6 d-flex justify-content-center">
                    <div className="d-flex justify-content-center">
                        <form onClick={this.handleClick}>
                            <button className="btn btn-primary" type="submit">Add More</button>
                        </form>
                    </div>
                </div>
            </div>
        </React.Fragment>

    )}
}
export default AddItems